/**
 * Yandex.Metrika goals helper.
 * Wraps `ym()` calls so the rest of the app doesn't need to know
 * the counter ID or guard against missing `ym` global.
 */

const COUNTER_ID = 108587536;

declare global {
  interface Window {
    ym?: (id: number, action: string, target: string, params?: Record<string, unknown>) => void;
    dataLayer?: unknown[];
  }
}

/** Send a Metrika reachGoal event */
export function reachGoal(target: string, params?: Record<string, unknown>) {
  try {
    window.ym?.(COUNTER_ID, 'reachGoal', target, params);
  } catch {
    // silently ignore — Metrika might be blocked by adblock
  }
}

/** Push an ecommerce event to dataLayer (Metrika ecommerce) */
export function ecommercePush(action: string, products: unknown[]) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ecommerce: {
        [action]: { products },
      },
    });
  } catch {
    // silently ignore
  }
}

// ─── Goal names (keep in sync with Metrika UI) ─────────────────────────────

/** User logged in via Steam — ключевая цель */
export const GOAL_LOGIN = 'login_steam';

/** User clicked "Buy" on a listing */
export const GOAL_PURCHASE_CLICK = 'purchase_click';
/** API createPurchase succeeded, payment form submitted */
export const GOAL_PURCHASE_CONFIRM = 'purchase_confirm';
/** Purchase ended with an error (API or payment) */
export const GOAL_PURCHASE_ERROR = 'purchase_error';
/** Order status reached DONE (skin delivered) — ключевая цель */
export const GOAL_PURCHASE_DELIVERED = 'purchase_delivered';

/** User initiated a deposit (clicked "Пополнить") */
export const GOAL_DEPOSIT_INIT = 'deposit_init';
/** Deposit createDeposit API call succeeded, payment form submitted — ключевая цель */
export const GOAL_DEPOSIT_SUCCESS = 'deposit_success';

/** User saved Steam Trade URL */
export const GOAL_TRADE_URL_SET = 'trade_url_set';
